/**
 * 已封装至插件中，但需恢复到项目中引入的方法
 */
export default {
  methods: {
    /** 处理应用范围下拉（系统消息、推送通知） */
    handleRangeSelect (data) {
      this.formList[5].options = data;
      this.scopeList = data;
      let list = data.map(item => ({ ...item }));
      list.splice(1, 2);
      this.rangeList = list;
    },
    /** 推送目标change事件 */
    pushTarget (e) {
      e = e.target.value;
      let scope = this.formList[5];
      if (e === '8') {
        scope.options = this.rangeList;
      } else {
        scope.options = this.scopeList;
      }
    },
    /** 处理小区选择 change */
    rangeCommunityChange (e) {
      let options = this.formList[7].options;
      if (e.length >= 20) {
        options.forEach(item => {
          if (e.every(part => part !== item.key)) {
            item.disabled = true;
          }
        });
      }

      if (e.length === 0) {
        options.forEach(item => {
          item.disabled = false;
        });
      }
    },
    /** 处理小区选择 selected */
    rangeCommunitySelected (source, target) {
      let options = this.formList[7].options;
      let targetKeys = this.$refs.addEdit.targetKeys;
      if (source.length + targetKeys.length >= 20) {
        options.forEach(item => {
          if ([...source, ...targetKeys].every(part => part !== item.key)) {
            item.disabled = true;
          }
        });
      } else {
        options.forEach(item => {
          item.disabled = false;
        });
      }
    },
    /** 限制选择城市、小区最多20个 */
    rangeCityChange (e) {
      let options = this.formList[6].options;
      if (e.length >= 20) {
        this.handleCityOptions(options, e);
        e.splice(20, e.length - 20);
      } else {
        this.handleCityOptions(options);
      }
    },
    handleCityOptions (options, e) {
      options.forEach(item => {
        if (e) {
          if (e.every(part => part !== item.value)) {
            item.disabled = true;
          }
        } else {
          item.disabled = false;
        }

        if (item.children && item.children.length) {
          this.handleCityOptions(item.children, e);
        }
      });
    },
    /* 处理用户范围提交值 */
    rangeReqVal (param) {
      let scopeArr = ['cityScope', 'communityScope', 'accountScope'];
      scopeArr.forEach((el) => {
        for (let item in param) {
          if (el === item) {
            param.scope = param[item];
          }
        }
      });
      typeof param.scope === 'undefined' && (param.scope = '0');
      return param;
    },
    /* 处理用户范围返回值 */
    rangeResVal (values, res) {
      let scopeType = {
        1: 'cityScope',
        2: 'communityScope',
        3: 'accountScope'
      };
      let type = [1, 2].some(el => el === res.scopeType);
      values[scopeType[res.scopeType]] = type ? formatScope() : res.scope;
      function formatScope () {
        let arr = res.scope && res.scope.split(',');
        if (res.scopeType === 1) {
          let cityArr = [];
          arr.forEach((el) => {
            cityArr.push((el));
          });
          return cityArr;
        }
        return arr; // formatScope返回
      }
      return values; // 整个函数返回
    },
    /* 处理定时发送单选框 */
    handleDealyTime (value) {
      let index;
      this.formList.forEach((el, i) => {
        let props = el.props;
        if (props && props[0] === 'isDelay') {
          index = i;
        }
      });
      let delayTime = this.formList[index].dateProps[1].rules[0];
      let list = this.formList[index];
      value === 1 ? delayTime.required = true : delayTime.required = false;
      value === 1 ? list.pickerDisabled = false : list.pickerDisabled = true;
      this.$children[0].form.resetFields(['delayTime']);
    },
    /* 限制修改上级 */
    limitEdit (res, keyArr) {
      res.canDelete === 0 && this.formList.forEach((el) => {
        keyArr.forEach((item) => {
          if (el.props && el.props[0] === item) {
            el.disabled = true;
          }
        });
      });
    }
  }
};
